<script lang="ts" setup>
import { computed } from 'vue'
import { useTypedRoute } from '@/composables'
import { useThemeFlags } from '@/composables/useThemeFlags'

const route = useTypedRoute<any>()
  const { isDark } = useThemeFlags()

  const pageKey = computed<'home' | 'kubernetes' | 'webhosting' | 'domains'>(() => {
    const n = String(route.name || '')
    if (n.includes('kubernetes')) return 'kubernetes'
    if (n.includes('webhosting')) return 'webhosting'
    if (n.includes('domains')) return 'domains'
    if (n.includes('domain')) return 'domains'
    return 'home'
  })

  const imageUrl = computed(() => {
    switch (pageKey.value) {
      case 'kubernetes':
        return '/media/background-kubernetes.svg'
      case 'webhosting':
        return '/media/background-webhosting.svg'
      case 'domains':
        return '/media/background-domains.svg'
      default:
        return '/media/background-home.svg'
    }
  })

  const overlayOpacity = computed(() => {
    return '0.1'
  })

  const bgStyle = computed(() => {
    const url = `url('${imageUrl.value}')`
    const style: Record<string, string> = {
      '--overlay-opacity': overlayOpacity.value
    }
    const grad = isDark.value
      ? 'radial-gradient(60% 40% at 50% 10%, rgba(0,176,255,0.20), rgba(0,0,0,0) 60%)'
      : 'radial-gradient(60% 40% at 50% 10%, rgba(28,110,227,0.12), rgba(0,0,0,0) 60%)'
    style.backgroundImage = `${grad}, ${url}`
    return style
  })
</script>

<template>
  <div :style="bgStyle" aria-hidden="true" class="global-bg"></div>
</template>

<style scoped>
  .global-bg {
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .global-bg::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, var(--overlay-opacity, 0.2));
  }

  @media (prefers-reduced-motion: reduce) {
    .global-parallax .layer {
      transform: none !important;
      background-attachment: fixed;
    }
  }
</style>
